import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { SubSede } from '../models/subSede';
import { environment } from '../../environments/environment';

const baseUrl = environment.hostService + '/SubSedes';

@Injectable({
  providedIn: 'root'
})
export class SubSedeService {
   
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getSubSedes(code): Observable<any> {
    return this._http.get<any>({ url: baseUrl + '/GetBySede?sedeId=' + code })
  }

  save(subSede: SubSede)
  {
    return this._http.post({ url: baseUrl + '/Save', body: subSede });
  }

  delete(id: number)
  {
    return this._http.get({ url: baseUrl + '/Delete?id=' + id});
  }
}
